interface LogoProps {
  size?: string;
  className?: string;
}

export default function Logo({ size = 'w-8 h-8', className = '' }: LogoProps) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${size} ${className}`}
      aria-hidden="true"
    >
      {/* Outer rounded container */}
      <rect x="1" y="1" width="30" height="30" rx="7" stroke="currentColor" strokeWidth="1.6" opacity="0.25" />

      {/* Top-left: "0" — capsule/rect */}
      <rect x="7" y="6.5" width="6" height="8" rx="2.5" stroke="currentColor" strokeWidth="2" />
      {/* Top-right: "1" — solid bar */}
      <rect x="19.5" y="6.5" width="2.8" height="8" rx="1.4" fill="currentColor" />

      {/* Bottom-left: "1" — solid bar */}
      <rect x="8.6" y="18" width="2.8" height="8" rx="1.4" fill="currentColor" />
      {/* Bottom-right: "0" — capsule/rect */}
      <rect x="17.9" y="18" width="6" height="8" rx="2.5" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
}
